module.exports = isHook

function isHook(hook) {
    return hook &&
      (typeof hook.hook === "function" && !hook.hasOwnProperty("hook") ||
       typeof hook.unhook === "function" && !hook.hasOwnProperty("unhook"))
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vnode/is-vhook.js
// module id = 67
// module chunks = 7